/* eslint-disable react/no-unused-state */
import React, { Component, createContext } from 'react';

export {
  default as useFocusReceiver,
  scrollToElement,
  scrollToAndHighlightElement,
} from './useFocusReceiver';

const { Provider, Consumer } = createContext({});

const noop = () => {};

class FocusProvider extends Component {
  constructor(props) {
    super(props);

    this.state = {
      requestFocusOn: this.requestFocusOn,
      subscribeToFocusRequestsOn: this.subscribeToFocusRequestsOn,
      subscribeToAnyFocusRequest: this.subscribeToAnyFocusRequest,
    };

    this.listeners = new Map();
    this.catchAllListeners = new Set();
  }

  componentWillUnmount() {
    this.listeners.clear();
    this.catchAllListeners.clear();
  }

  requestFocusOn = id => {
    (this.listeners.get(id) || noop)(id);
    this.catchAllListeners.forEach(cb => cb(id));
  };

  subscribeToFocusRequestsOn = (id, callback) => {
    this.listeners.set(id, callback);

    return () => this.listeners.delete(id);
  };

  subscribeToAnyFocusRequest = callback => {
    this.catchAllListeners.add(callback);

    return () => this.catchAllListeners.delete(callback);
  };

  render() {
    return <Provider {...this.props} value={this.state} />;
  }
}

FocusProvider.Consumer = Consumer;

export default FocusProvider;



// WEBPACK FOOTER //
// ./src/setup/FocusProvider/index.js